import { Pipe, PipeTransform } from '@angular/core';
import { differenceInCalendarDays, differenceInDays, format } from 'date-fns';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'daysAgoDisplayDateFormatter',
})
export class DaysAgoDisplayDateFormatterPipe extends DatePipe implements PipeTransform {
  override transform(value: any, args?: any): any {
    const date = new Date(value);
    const today = new Date();
    const daysDifference = differenceInCalendarDays(today, date);

    if (daysDifference === 0) {
      return 'Today, ' + format(date, 'h:mmaaa');
    } else if (daysDifference === 1) {
      return 'Yesterday, ' + format(date, 'h:mmaaa');
    } else if (daysDifference > 0 && daysDifference <= 7) {
      return `${daysDifference} days ago`;
    } else {
      return super.transform(value, args);
    }
  }
}
